import { FieldHtmlNameUtil, Trans } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSinupScreen from './AbstractStartSignupScreen';

export default class LandingSignupScreen extends AbstractStartSinupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-landing';

  public predicate(): boolean {
    return this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.landingPage)
      && this.sessionInfo.value.emailCheckCode === null;
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    this.getField(FieldHtmlNameUtil.email).label = Trans.by('Business Email', 'businessEmail');
    return super.getVisibleComponents();
  }

  // eslint-disable-next-line class-methods-use-this
  public isInitialScreen(): boolean {
    return true;
  }
}
